import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const SurveyScoresTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Survey Category",
			dataIndex: "survey_category",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{record.name}</span>;
			},
		},
		{
			title: "Score Start",
			dataIndex: "score_start",
			width: 80,
			ellipsis: true,
		},
		{
			title: "Score End",
			dataIndex: "score_end",
			width: 80,
			ellipsis: true,
		},
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default SurveyScoresTable;
